<template>
	<el-button size="small"
        style="margin-right: 10px"
        v-if="getFichaById(id).section.left && !getFichaById(id).section.left.static"
        @click="setFichaVisibleSection({id, section: 'left'})"
        :icon="getFichaById(id).section.left.open ? 'el-icon-document' : 'el-icon-document'"
        />
</template>

<script>
    import { mapMutations, mapGetters } from 'vuex'
	export default {
		name: 'OpenDrawerLeft',
		props: {
            id: [Number,String],
			ficha: Object
		},
        computed: {
            ...mapGetters([
				'getFichaById'
			])
        },
        methods: {
            ...mapMutations([
				'setFichaVisibleSection'
			])
        }
	}
</script>

<style lang="scss"></style>
